import React, { useState } from 'react';

const InfoTooltip = ({ title, content, placement = 'top' }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="d-inline-block position-relative">
      <i 
        className="fas fa-info-circle text-info ms-2" 
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
      ></i>
      {showTooltip && (
        <div 
          className="position-absolute bg-dark text-white p-2 rounded shadow"
          style={{
            zIndex: 1000,
            minWidth: '200px',
            maxWidth: '300px',
            fontSize: '0.875rem',
            bottom: placement === 'top' ? '100%' : 'auto',
            top: placement === 'bottom' ? '100%' : 'auto',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: placement === 'top' ? '5px' : '0',
            marginTop: placement === 'bottom' ? '5px' : '0',
            pointerEvents: 'none'
          }}
        >
          {title && <div className="fw-bold mb-1">{title}</div>}
          <div>{content}</div>
          <div 
            className="position-absolute"
            style={{
              width: 0,
              height: 0,
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: placement === 'bottom' ? '5px solid #000' : 'none',
              borderBottom: placement === 'top' ? '5px solid #000' : 'none',
              left: '50%',
              transform: 'translateX(-50%)',
              top: placement === 'bottom' ? '-5px' : 'auto',
              bottom: placement === 'top' ? '-5px' : 'auto'
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;